
export default [
  {
    name:"VolumeAudit",
    path: '/volumeAudit/index',
    component: (resolve) => require(['@/views/volumeAudit/index'], resolve),
    meta: { title: 'Volume', noCache: false, affix: false },
    roles:[0,2,9]
  },

]
